const menu = [
  {
    id: 1,
    title: "Natural classic 70%",
    category: "Price List",
    price: 79,
    img: "./images/item-1.jpeg",
    desc: ``,
  },
  {
    id: 2,
    title: "Natural classic Full Set",
    category: "Price List",
    price: 95,
    img: "./images/item-2.jpeg",
    desc: ``,
  },
  {
    id: 3,
    title: "Wispy Classic Set",
    category: "Price List",
    price: 95,
    img: "./images/item-3.jpeg",
    desc: ``,
  },
  {
    id: 4,
    title: "Medium 2D Set",
    category: "Price List",
    price: 115,
    img: "./images/item-4.jpeg",
    desc: ``,
  },
  {
    id: 5,
    title: "Medium volume Set",
    category: "Price List",
    price: 125,
    img: "./images/item-5.jpeg",
    desc: ``,
  },
  {
    id: 6,
    title: "Wispy volume Set",
    category: "Price List",
    price: 125,
    img: "./images/item-6.jpeg",
    desc: ``,
  },
  {
    id: 7,
    title: "Mega volume Set",
    category: "Price List",
    price: 155,
    img: "./images/item-7.jpeg",
    desc: ``,
  },
  {
    id: 8,
    title: "Baby lash (invisible",
    category: "Lash Designs",
    price: 115,
    img: "./images/item-8.jpeg",
    desc: ``,
  },
  {
    id: 9,
    title: "Princess (Douyin)",
    category: "Lash Designs",
    price: 135,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 10,
    title: "Anime Set (Wet Look)",
    category: "Lash Designs",
    price: 155,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 11,
    title: "Lower lash",
    category: "Lash Designs",
    price: 45,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 12,
    title: "Lash removal",
    category: "Lash Designs",
    price: 30,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 13,
    title: "Lash tint",
    category: "Lash Designs",
    price: 25,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 14,
    title: "Lash lift only",
    category: "Lash Designs",
    price: 79,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 15,
    title: "Lash lift and tint",
    category: "Lash Designs",
    price: 95,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 16,
    title: "Brows wax",
    category: "Brows services",
    price: 20,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 17,
    title: "Brow tint",
    category: "Brows services",
    price: 20,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 18,
    title: "Brow wax and tint",
    category: "Brows services",
    price: 39,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 19,
    title: "Brow wax and henna",
    category: "Brows services",
    price: 59,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 20,
    title: "Brow lamination with tint",
    category: "Brows services",
    price: 95,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 21,
    title: "Ombre/ Powder Brows",
    category: "Brows services",
    price: 495,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 22,
    title: "Ombre/ Powder Brows second session",
    category: "Brows services",
    price: 295,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 23,
    title: "Eyebrow combination",
    category: "Brows services",
    price: 595,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 24,
    title: "Eyebrow combination second session",
    category: "Brows services",
    price: 295,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 25,
    title: "Upper lip & chin",
    category: "Waxing",
    price: 20,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 26,
    title: "Full face wax (incl. brows",
    category: "Waxing",
    price: 65,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 27,
    title: "Sideburn",
    category: "Waxing",
    price: 15,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 28,
    title: "Under arms",
    category: "Waxing",
    price: 15,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 29,
    title: "Half arms",
    category: "Waxing",
    price: 25,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 30,
    title: "Half legs",
    category: "Waxing",
    price: 35,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 31,
    title: "Full legs",
    category: "Waxing",
    price: 65,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 32,
    title: "Bikini wax",
    category: "Waxing",
    price: 35,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
  {
    id: 33,
    title: "Brazilian wax",
    category: "Waxing",
    price: 65,
    img: "./images/item-9.jpeg",
    desc: ``,
  },
];
export default menu;
